import * as types from './types'

export const getAddressAccessRequest = () => ({
  type: types.GET_ADDRESS_ACCESS_REQUEST,
})
export const getAddressAccessSuccess = (result) => ({
  type: types.GET_ADDRESS_ACCESS_SUCCESS,
  payload: result,
})
export const getAddressAccessError = (error) => ({
  type: types.GET_ADDRESS_ACCESS_ERROR,
  payload: error,
})
